import createBuyerIntentClick from './createBuyerIntentClick'

const BuyerIntentLeadClick = createBuyerIntentClick({
  displayName: 'BuyerIntentLeadClick',
  eventName: '/leads/create',
})

export default BuyerIntentLeadClick
